import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { PAGE_MAX_WIDTH, pagePaddingBottom, pagePaddingTop, pagePaddingX } from './constants';

export interface PageShellProps extends Omit<BoxProps, 'ref'> {
  /** Skip max-width / horizontal padding (full-bleed charts etc.) */
  fullBleed?: boolean;
}

/**
 * 콘텐츠 흐름상 마지막 블록.
 * UnifiedModal의 스와이프 영역(position: fixed)이 뒤에 붙는 페이지가 있어
 * 진짜 last-child와 "스와이프 영역 바로 앞" 둘 다 잡는다.
 */
const LAST_BLOCK = '*:is(:last-child, :has(+ .PrivateSwipeArea-root))';

/** 마지막 카드가 래퍼 몇 겹 안에 들어있는 페이지가 있어 이 깊이까지 훑는다. */
const TRAILING_CHAIN_DEPTH = 8;

/**
 * 페이지 끝 블록의 하단 마진을 지워 모든 화면의 하단 여백을 pagePaddingBottom으로 통일한다.
 * 마지막 블록만 따라가는 단일 체인이라 중간 콘텐츠 간격에는 영향이 없다.
 */
const trailingBlockMarginReset = Object.fromEntries(
  Array.from({ length: TRAILING_CHAIN_DEPTH }, (_, level) => [
    `& ${`> ${LAST_BLOCK} `.repeat(level + 1).trim()}`,
    { marginBottom: 0 },
  ]),
);

const PageShell = React.forwardRef<HTMLElement, PageShellProps>(function PageShell(
  { children, fullBleed = false, sx, ...rest },
  ref,
) {
  return (
    <Box
      ref={ref}
      sx={{
        width: '100%',
        minHeight: '100%',
        ...(fullBleed
          ? {}
          : {
              maxWidth: PAGE_MAX_WIDTH,
              mx: 'auto',
              px: pagePaddingX,
              pt: pagePaddingTop,
              pb: pagePaddingBottom,
              ...trailingBlockMarginReset
            }),
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
});

export default PageShell;
